import {connect} from 'react-redux'
import {compose} from "redux";
import ResetPassword from "./ResetPassword";
import {getErrorEntity, getLoadingEntity} from "../../../redux/selectors/ui/ui.selectors";
import {RESET_PASSWORD, postResetPassword} from "../../../redux/actions/app/password/password.actions";

const mapStateToProps = state => {
    return {
        loading: getLoadingEntity(state, RESET_PASSWORD),
        errorState: getErrorEntity(state, RESET_PASSWORD),
    }
}

const mapDispatchToProps = {
    postResetPassword
}

const ResetPasswordContainer = compose(
    connect(mapStateToProps, mapDispatchToProps)
)(ResetPassword)

export default ResetPasswordContainer
